import { SET_SHOP_CONTEXT } from "../types";
import { ShopState } from "../types/ShopTypes";

const set_shop_dispatch = (shopState: ShopState) => ({
  type: SET_SHOP_CONTEXT,
  data: shopState,
});

export { set_shop_dispatch };
